import { Toast } from 'bootstrap';

const toast = {
  namespaced: true,
  state: {
    title: '알림',
    description: '',
    type: '',
    showCloseButton: false,
  },
  getters: {
    title: (state) => state.title,
    description: (state) => state.description,
    type: (state) => state.type,
    showCloseButton: (state) => state.showCloseButton,
  },
  mutations: {
    setTitle: (state, payload) => (state.title = payload),
    setDescription: (state, payload) => (state.description = payload),
    setType: (state, payload) => (state.type = payload),
    setShowCloseButton: (state, payload) => (state.showCloseButton = payload),
    init: (state) => {
      state.title = '알림';
      state.description = '';
      state.type = '';
      state.showCloseButton = false;
    },
  },
  actions: {
    show: (store, payload) => {
      console.log(payload?.description?.length);
      if (payload?.title?.length > 0) {
        store.commit('setTitle', payload?.title);
      }
      if (payload?.description?.length > 0) {
        store.commit('setDescription', payload?.description);
      }
      if (payload?.type?.length > 0) {
        store.commit('setType', payload?.type);
      }
      // showCloseButton 옵션 처리 (기본값: false)
      const showCloseButton = payload?.showCloseButton ?? false;
      store.commit('setShowCloseButton', showCloseButton);

      const toastElem = document.getElementById('pop-toast');
      // 자동 닫기 옵션 설정 (기본값: true, 3초)
      const autoHide = payload?.autoHide !== false; // 기본값: true
      const delay = payload?.delay ?? 3000; // 기본값: 3000ms (3초)
      
      var toast = new Toast(toastElem, {
        autohide: autoHide,
        delay: delay,
      });
      
      toastElem.addEventListener('hidden.bs.toast', () => {
        store.commit('init');
      });
      toast.show();
    },
  },
};

export default toast;
